/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "சேர்க்கவும்"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "அனைத்தையும் அகற்றுக"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var taIN = Object.assign(TranslationProviderComponent, {
  translations
});

export { taIN as t };
//# sourceMappingURL=ta-IN-CGYMjUny.js.map
